import React, { Fragment, useRef, useState } from 'react';
import selectUp from '../assets/images/select-up.png';
import closeButton from '../assets/images/Vector 32.svg';
import { useDispatch, useSelector } from 'react-redux';
import { setChapter, setSection } from '../Store/ui/reader';
import Down from '../images/down.svg';
import arrowUp from '../assets/images/arrow-up.svg';
import arrowDown from '../assets/images/arrow-down.svg';
import Correct from '../assets/images/green-circle.svg';
import YellowCircle from '../assets/images/yellow-circle.svg';
import Incorrect from '../assets/images/red-circle.svg';
import Incomplete from '../assets/images/incomplete-circle.svg';
import Inprogress from '../assets/images/Inprogress.svg';
import Submitted from '../assets/images/submitted-circle.svg';
import moment from 'moment';
import RightsidebarGreybox from '../components/RightsidebarGreybox';
import { Link, useNavigate } from 'react-router-dom';
import 'react-quill/dist/quill.snow.css';
import { useEffect } from 'react';
import { byBookActivityAnswer } from '../Store/api/activities';
import MediaComponent from './activity/MediaComponent';
import EditorInput from './activity/EditorInput';
import SideBarBlanks from './studentDashboard/sideBarBlanks';
import { formatDate as dateFormat } from '../utils';
import CompleteActivityDuetoNext from './CompleteActivityDuetoNext';
export const StudentRightSidebar = (props) => {
  const { activities, activitiesByAssignedDate } = useSelector(
    (state) => state.entities.student.book
  );

  const { book } = useSelector((state) => state.entities.student);
  const [creatingActivity, setCreatingActivity] = useState(false);
  const [opendate, setOpenedDate] = useState('');
  const [monthActivity, setMonthActivity] = useState(false);
  const [arrowImage, setArrowImage] = useState(false);
  const [complteDueNext, setComplteDueNext] = useState(false);
  const [activityByBook, setActivityByBook] = useState([]);
  const [dueNextFilter, setDueNextFilter] = useState(false);
  const [pastDueFilter, setPastDueFilter] = useState(false);
  const [completedFilter, setCompletedFilter] = useState(false);
  const [filteredActivities, setFilteredActivities] = useState([]);
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();

  // .filter(item => item.book === '')
  /* Sorting Aactivities based on Due Date, Due Past and Submitted */
  const sortedActivities = filteredActivities.slice().sort((a, b) => {
    const dateA = new Date(a.assignedDate);
    const dateB = new Date(b.assignedDate);
    return dateB - dateA; // Sorting in descending order
  });

  /* ..................... */
  /* Filter aCtivitiy */
  useEffect(() => {
    // Logic to filter activities based on checkbox state
    const filtered = activityByBook.filter((activity) => {
      const assignedDate = activity.assignedDate ? new Date(activity.assignedDate) : null;
      const currentDate = new Date();

      if (dueNextFilter) {
        if (
          assignedDate &&
          assignedDate.setHours(0, 0, 0, 0) >= currentDate.setHours(0, 0, 0, 0) &&
          activity.activityAnswers &&
          activity.activityAnswers.some(
            (answer) => !answer.isGraded && answer.activityStatus === 'NotStarted'
          )
        ) {
          return true;
        }
        return false;
      }
      if (pastDueFilter) {
        if (
          assignedDate &&
          assignedDate.setHours(0, 0, 0, 0) < currentDate.setHours(0, 0, 0, 0) &&
          activity.activityAnswers &&
          activity.activityAnswers.some((answer) => !answer.answers.length > 0)
        ) {
          return true;
        }
        return false;
      }

      if (completedFilter) {
        if (
          activity.activityAnswers &&
          activity.activityAnswers.some(
            (answer) =>
              (answer.answers.length && answer.isGraded) ||
              (!answer.isGraded && answer.activityStatus === 'Completed')
          )
        ) {
          return true;
        }
        return false;
      }

      return true;
    });

    setFilteredActivities(filtered);
  }, [dueNextFilter, pastDueFilter, completedFilter, activityByBook]);

  const handleCheckboxChange = (filterType) => {
    // Toggle the state of the clicked checkbox and uncheck others
    setDueNextFilter(filterType === 'dueNext' ? !dueNextFilter : false);
    setPastDueFilter(filterType === 'pastDue' ? !pastDueFilter : false);
    setCompletedFilter(filterType === 'completed' ? !completedFilter : false);
  };

  const handleClearAll = () => {
    // Clear all checkboxes and show all activities
    setDueNextFilter(false);
    setPastDueFilter(false);
    setCompletedFilter(false);
    setActivityByBook(activityByBook);
  };

  /* ....................................end */
  useEffect(() => {
    const openedDate = localStorage.getItem('openedDate');

    if (openedDate) {
      setComplteDueNext(true);
      setOpenedDate(openedDate);
      // localStorage.removeItem("openedDate");
    }
  }, []);

  /* Use effect for Activities of each book */
  useEffect(() => {
    setLoading(true);
    if (book.name || book.subject || book.owner)
      dispatch(
        byBookActivityAnswer({
          id: book._id,
          onSuccess: (res) => {
            setActivityByBook(res.data.data);

            setLoading(false);
          },
          onError: (err) => {
            setLoading(false);
          },
        })
      );
  }, [book._id]);

  /* .......................... */
  const HandleToogle = () => {
    setMonthActivity(!monthActivity);
    setArrowImage(!arrowImage);
  };
  const { settings } = useSelector((state) => state.settings.settings);

  return (
    <div
      className=' col-xl-5 col-lg-12 right_bar_new pt-132 left_side_bar pt-0 pb-0 edite_box_right'
      style={{
        width: '36.666667%',
        padding: '0px',
        position: 'relative',
        background: 'var(--Grey-100, #FAFAF9)',
      }}
    >
      {!complteDueNext && (
        <div
          className={`right_bar_new_inner ${settings.bookMode ? 'd-none' : ''}`}
          style={{ overflowY: 'clip' }}
        >
          <div
            className='welcome_wrap  custom_nav  pl-0 mt-0 main_content_tabs'
            style={{ paddingRight: '0px' }}
          >
            <ul className='nav nav-tabs nav-justified' id='myTab' role='tablist'>
              <li className='nav-item' role='presentation'>
                <button
                  className='nav-link active'
                  id='home-tab'
                  data-bs-toggle='tab'
                  data-bs-target='#class-activities'
                  type='button'
                  role='tab'
                  aria-controls='class-activities'
                  aria-selected='true'
                >
                  activities
                </button>
              </li>
              <li className='nav-item' role='presentation'>
                <button
                  className='nav-link'
                  id='account_cards-tab'
                  data-bs-toggle='tab'
                  data-bs-target='#account_cards'
                  type='button'
                  role='tab'
                  aria-controls='profile'
                  aria-selected='false'
                >
                  flash cards
                </button>
              </li>
            </ul>
            <div className='tab-content' id='ClassInfo'>
              <div
                className='tab-pane fade show active'
                id='class-activities'
                role='tabpanel'
                aria-labelledby='class-activities-tab'
              >
                <div className='right_bar_new_tabs'>
                  <div className='header-options d-flex justify-content-center align-items-center'>
                    <div className='iagree_radio blanks-opt-right'>
                      <input
                        type='checkbox'
                        id='Due_next'
                        checked={dueNextFilter}
                        onChange={() => handleCheckboxChange('dueNext')}
                      />
                      <label htmlFor='Due_next'>Due next </label>
                    </div>
                    <div className='iagree_radio blanks-opt-right'>
                      <input
                        type='checkbox'
                        id='Past_due'
                        checked={pastDueFilter}
                        onChange={() => handleCheckboxChange('pastDue')}
                      />
                      <label htmlFor='Past_due'>Past due</label>
                    </div>
                    <div className='iagree_radio blanks-opt-right'>
                      <input
                        type='checkbox'
                        id='Completed'
                        checked={completedFilter}
                        onChange={() => handleCheckboxChange('completed')}
                      />
                      <label htmlFor='Completed'>Completed </label>
                    </div>
                    <div className='clear-list' onClick={handleClearAll}>
                      Clear
                    </div>
                  </div>

                  <div className='activities-right-side'>
                    {loading ? (
                      [...new Array(5)].map((_, index) => <LoadingActivites key={index} />)
                    ) : (
                      <Fragment>
                        {sortedActivities.map((activity, index) => {
                          return (
                            (pastDueFilter || dueNextFilter || completedFilter || activity) && (
                              <MCQsActivity
                                scrollToParagraph={props.scrollToParagraph}
                                scroll={props.scroll}
                                activity={activity}
                                highlightedP={props.highlightedParagraph}
                                spreadActivitiesSetter={props.spreadActivitiesSetter}
                                activities={activities}
                                activitiesByAssignedDate={activitiesByAssignedDate}
                                index={index}
                                key={activity._id}
                                loading={loading}
                              />
                            )
                          );
                        })}
                      </Fragment>
                    )}
                    <div style={{ height: '200px' }}></div>
                  </div>
                </div>
              </div>
              <CompleteActivity
                creatingActivity={creatingActivity}
                setCreatingActivity={setCreatingActivity}
              />
              <div
                className='tab-pane fade show '
                id='account_cards'
                role='tabpanel'
                aria-labelledby='account_cards'
              ></div>
            </div>
          </div>

          {!creatingActivity && (
            <div className='blurb-focused' style={{ bottom: '26px' }}>
              <div className='bottom_button_focus' style={{ position: 'relative' }}>
                <button
                  type='button'
                  className='create_btn std-creates'
                  style={{ width: '100%' }}
                  onClick={(e) => {
                    setComplteDueNext(true);
                  }}
                >
                  Activities due next <img src={selectUp} alt='up' />
                </button>
              </div>
            </div>
          )}
        </div>
      )}
      {complteDueNext && (
        <CompleteActivityDuetoNext
          setComplteDueNext={setComplteDueNext}
          activitiesByAssignedDate={activitiesByAssignedDate}
          mode='std-book'
        />
      )}
    </div>
  );
};

const MCQsActivity = (props) => {
  const { chapters } = useSelector((state) => state.entities.student.book);
  const [mcqsList, setMcqsList] = useState(false);
  const chaptersMap = chapters.reduce((acc, curr) => {
    acc[curr._id] = curr;
    return acc;
  }, {});
  const { book } = useSelector((state) => state.entities.student);
  const dispatch = useDispatch();
  const questionTypes = {
    mcqs: 'multiple choice',
    fr: 'long response',
    truefalse: 'true and false',
    matching: 'matching',
    blanks: 'fill in the blanks',
    sa: 'short response',
    or: 'order list',
  };
  /* For Date format */

  const assignedDate = new Date(props.activity.assignedDate);
  const month = (assignedDate.getMonth() + 1).toString().padStart(1, '0');
  const day = assignedDate.getDate().toString().padStart(2, '0');
  const year = assignedDate.getFullYear().toString().slice(-2);
  const formattedDate = `${month}.${day}.${year}`;

  /* End........... */
  /* Total score of all activities */
  const totalScore = props?.activity?.questions?.reduce((accumulator, question) => {
    // Convert question.score to a number using parseInt
    const score = parseInt(question.score, 10);

    // Check if the conversion is successful (not NaN)
    if (!isNaN(score)) {
      return accumulator + score;
    }
  }, 0);

  const order = chaptersMap[props.activity.chapter]
    ? chaptersMap[props.activity.chapter].order
    : '';
  const chapter = chaptersMap[props.activity.chapter];
  const sectionIndex = chapter
    ? chapter.sections.findIndex((e) => e._id === props.activity.section)
    : -1;
  const assingedDate = new Date(props.activity.assignedDate);

  const setActivity = () => {
    const section = props.activity.section;
    const chapter = props.activity.chapter;
    const paragraph =
      props.activity.paragraphs && props.activity.paragraphs.length
        ? props.activity.paragraphs[0]
        : null;
    const chapIndex = book.chapters.findIndex((e) => e._id === chapter);
    if (chapIndex >= 0) {
      const secIndex = book.chapters[chapIndex].sections.findIndex((e) => e._id === section);
      if (chapIndex >= 0) dispatch(setChapter(chapIndex));
      if (secIndex >= 0) dispatch(setSection(secIndex));
      if (!paragraph) {
        props.scroll(secIndex, chapIndex);
      } else {
        props.scrollToParagraph(props.activity.chapter, props.activity.section, paragraph);
      }
    }
  };
  const isCompleted =
    props.activity.activityAnswers &&
    props.activity.activityAnswers.length > 0 &&
    props.activity.activityAnswers.some(
      (answer) => answer.isGraded || (!answer.isGraded && answer.activityStatus === 'Completed')
    );

  const isPastDate =
    assingedDate.setHours(0, 0, 0, 0) < new Date().setHours(0, 0, 0, 0) &&
    props.activity.activityAnswers.some((answer) => !answer.answers.length > 0);
  const isNextDate = assingedDate.setHours(0, 0, 0, 0) >= new Date().setHours(0, 0, 0, 0);
  props.activity.activityAnswers.some((answer) => !answer.isGraded);

  let message = '';
  let color = 'inherit';

  if (isCompleted) {
    message = 'Completed';
    color = '#0A5C59';
  } else if (isNextDate) {
    message = `Due ${formattedDate}`;
    color = 'inherit';
  } else if (isPastDate) {
    message = `Past Due ${formattedDate}`;
    color = '#AE2604';
  }

  return (
    <div className='question_box_new' key={props.activity._id}>
      <h5 className='event-less font-inter position-relative'>
        {props.activity.graded === 'auto' ? 'auto-graded' : 'teacher-graded'}{' '}
        <span style={{ color }}>
          <span className='font-inter'>{message}</span>
        </span>
      </h5>
      <div className='d-flex justify-content-between'>
        <a
          href='#!'
          className='chapt-link cursor font-inter'
          onClick={(e) => {
            e.stopPropagation();
            setActivity();
          }}
        >
          chapter {order}
          {sectionIndex > -1 ? ', section ' + (sectionIndex + 1) : ''}
        </a>
        <Link className='text-right font-inter' to={`/studentfocusedmode/${props.activity._id}`}>
          {props.activity?.activityAnswers?.[0]?.isGraded
            ? props.activity?.activityAnswers?.[0].grade === 100
              ? 'view'
              : new Date(props.activity.assignedDate).setHours(0, 0, 0, 0) >=
                new Date().setHours(0, 0, 0, 0)
              ? 'redo'
              : 'view'
            : 'start'}
        </Link>
      </div>
      <h2 className='event-less compact-title pt-3'>{props.activity.title}</h2>
      <div className='d-flex align-items-center justify-content-between'>
        <div className='f_12 mb-0 d-flex justify-content-between align-items-center'>
          <span className='fs-12 font-inter text_grey'>
            <b className='fw-700'>{totalScore ? totalScore : 0}</b> pts |{' '}
            <span className='fw-700'>{props?.activity?.questions?.length}</span> questions
          </span>
        </div>
        {!mcqsList && (
          <div
            className='cursor std activity-open-btn'
            onClick={(e) => {
              e.stopPropagation();
              e.preventDefault();
              props.spreadActivitiesSetter(props?.activity?._id);
              setMcqsList((prev) => !prev);
            }}
          >
            Open
            <img
              src={arrowDown}
              alt='arrow'
              style={{
                transform: `${mcqsList ? 'rotate(-180deg)' : ''}`,
                transition: '.5s',
              }}
            />
          </div>
        )}
      </div>
      <div className='chapter_wrap'>
        {mcqsList && (
          <Fragment>
            <div className='expend_mcqs'>
              <div>
                <div className='questions fts__14 fw-normal mt-2'>
                  <p className=' mb-2'>{props?.activity?.description}</p>
                </div>
              </div>
              {/* {props?.activity?.activityInstructionUrl && (
                <div style={{ justifyContent: 'center', display: 'flex' }}>
                  <div style={{ width: '100%' }}>
                    {['text', 'image', 'video', 'audio'].includes(
                      props?.activity?.activityInstructionsType
                    ) && (
                      <MediaComponent
                        media={{
                          url: props?.activity?.activityInstructionUrl || '',
                          type: props?.activity?.activityInstructionsType || 'text',
                        }}
                        mode='student'
                      />
                    )}
                  </div>
                </div>
              )} */}

              <div className='other_Wrap_question'>
                {props.activity.questions.map((question, questionIndex) => (
                  <ViewQuestions
                    key={questionIndex}
                    isCompleted={isCompleted}
                    questionTypes={questionTypes}
                    question={question}
                    questionIndex={questionIndex}
                    activity={props.activity}
                    // editorContent={editorContent}
                  />
                ))}
              </div>
            </div>
          </Fragment>
        )}
      </div>
      {mcqsList && (
        <div
          className='cursor std activity-open-btn'
          onClick={(e) => {
            e.stopPropagation();
            e.preventDefault();
            props.spreadActivitiesSetter(props?.activity?._id);
            setMcqsList((prev) => !prev);
          }}
        >
          {mcqsList ? 'Close' : 'Open'}{' '}
          <img
            src={arrowDown}
            alt='arrow'
            style={{
              transform: `${mcqsList ? 'rotate(-180deg)' : ''}`,
              transition: '.5s',
            }}
          />
        </div>
      )}
    </div>
  );
};

const CompleteActivity = ({ creatingActivity, setCreatingActivity }) => {
  return (
    <Fragment>
      {creatingActivity ? (
        <div
          className={`custom_nav templates_modal_inner`}
          id='templates_wrap'
          /* style={{
          display: creatingActivity === undefined ? "none" : "",
        }} */
        >
          <div className='inner_right'>
            <div
              className='collapse_btn top_postion'
              onClick={(e) => {
                e.preventDefault();
                setCreatingActivity(false);
              }}
            >
              <img src={Down} alt='' />
              <br />
              <a href='#!' className='btn btn-link btn_back'>
                collapse
              </a>
            </div>
          </div>
        </div>
      ) : null}
    </Fragment>
  );
};

function ViewQuestions({
  questionTypes,
  question,
  questionIndex,
  activity,
  isCompleted,
  editorContent,
}) {
  const [isExpanded, setIsExpanded] = useState(false);
  const actvityAnswer = activity.activityAnswers.filter((actyAnswer) => actyAnswer.answers);
  const inputRefs = useRef([]);
  const [error] = useState({});

  const toggleExpand = () => {
    setIsExpanded((prev) => !prev);
  };
  /* For showing input data */

  const activityAnswersWithFRType = activity?.activityAnswers.filter((activityAnswer) =>
    activityAnswer.answers.some((ans) => ans.type === 'fr' || ans.type === 'sa')
  );

  // Now, extract only the 'fr' type answers
  const frAnswers = activityAnswersWithFRType
    .map((activityAnswer) =>
      activityAnswer.answers.filter((ans) => ans.type === 'fr' || ans.type === 'sa')
    )
    .flat(); // Flatten the array if you want a single array of answers

  // ............

  const blankAnswer = activity?.activityAnswers[0]?.answers.filter(
    (ans) => ans.studentSelectedBanks.length > 0
  );
  const matchedAnswer = activity?.activityAnswers?.find((ans) =>
    ans.answers?.some((a) => a.question === question._id)
  );
  return (
    <div className='multipal_choic' key={questionIndex}>
      <h5 className='event-less mb-2 font-inter fw-semibold text-grey-700'>
        {questionTypes[question.type]}
      </h5>
      <h1 className='event-less mb-2 font-inter fw-semibold text-grey'> {question.text}</h1>
      {/* <div style={{ justifyContent: 'center', display: 'flex' }}>
        <div style={{ width: '100%' }}>
          {['text', 'image', 'video', 'audio'].includes(question?.questionInstructionsType) && (
            <MediaComponent
              media={{
                url: question?.questionMediaTypeUrl || '',
                type: question?.questionInstructionsType || 'text',
              }}
              mode='student'
            />
          )}
        </div>
      </div> */}
      <p className='fts__14 mb-0 d-flex justify-content-between align-items-center w-100 text-lowercase'>
        <span className='fw-semibold'>
          {isCompleted && matchedAnswer?.grade !== undefined && `${matchedAnswer.grade}% | `}
          {question.type === 'mcqs' ? (
            <Fragment>{question.options.length} answers</Fragment>
          ) : question.type === 'blanks' ? (
            <Fragment>{question.blanksBank.length} Blanks</Fragment>
          ) : (
            questionTypes[question.type]
          )}
        </span>
        <h4
          className='v_more cursor font-inter fs-11 text-grey-700 text-uppercase'
          onClick={toggleExpand}
        >
          <u>{isExpanded ? 'hide answers' : 'show answers'}</u>
        </h4>
      </p>
      {isExpanded && (
        <Fragment>
          {question.type === 'mcqs' || question.type === 'truefalse' ? (
            <div
              className={`mcqs-parent-student-focused mr-tp-b `}
              style={{ display: question.type === 'truefalse' ? 'flex' : '' }}
            >
              {question.options.map((option, index) => {
                const answerData = actvityAnswer[questionIndex]?.answers?.[0];

                return (
                  <div
                    // style={{marginBottom: "10px"}}
                    className={`mcqs-child cursors ${
                      question.type === 'truefalse' ? 'true-false_option' : ''
                    } ${['image', 'video'].includes(option.type) && 'pdb-0'} ${
                      answerData?.answerIndex === index ? 'parent-boarder selected' : ''
                    }  `}
                    key={index}
                  >
                    <div
                      className={`first_child `}
                      style={{ paddingBottom: '0px', cursor: 'default' }}
                    >
                      <div className='option_index'>{String.fromCharCode(65 + index)}</div>
                      <div className='child-b'>{option.text}</div>
                    </div>
                    {['image', 'video', 'audio'].includes(option.type) && (
                      <MediaComponent media={option} mode={'student'} />
                    )}
                  </div>
                );
              })}
            </div>
          ) : ['fr', 'mix', 'sa'].includes(question.type) ? (
            <EditorInput
              questionIndex={questionIndex}
              answersRead={frAnswers[0]?.answerText || ''} // Pass as a string, not an array
              isRead={true}
              mode='assign'
              question={question}
            />
          ) : (
            question.type === 'blanks' && (
              <SideBarBlanks
                question={question}
                error={error}
                inputRefs={inputRefs}
                blankAnswer={blankAnswer}
              />
            )
          )}
          {/*  {question.type === "mcqs" && (
            <div className="saved-correct mr-tp-bt">
              <span>Saved</span>
              <div>
          Correct <img src={checkMark} alt="" />
        </div>
            </div>
          )} */}
          {/*   {question.type === "fr" && (
            <div className="saved-correct " style={{marginTop: "-20px"}}>
              <span>Saved</span>
              <div>To be graded</div>
            </div>
          )} */}
        </Fragment>
      )}
    </div>
  );
}
const LoadingActivites = () => (
  <div className='question_box_new'>
    {/* <div className="book_main_img">
      <h4 className="content-skeleton m-0"></h4>
    </div> */}
    <div className='text_right' style={{ padding: '0px' }}>
      <div className='book_name' style={{ gap: '9.8px' }}>
        <h6 className='content-skeleton m-0' style={{ height: '12px', width: '115px' }}></h6>
        <h5 className='content-skeleton m-0' style={{ height: '12px', width: '115px' }}></h5>
        <div className='book_title_container w-100' style={{ paddingTop: '10px' }}>
          <h4 className='content-skeleton m-0' style={{ height: '18px', width: '115px' }}></h4>
        </div>
        <h5 className='content-skeleton m-0' style={{ height: '14px', width: '115px' }}></h5>
      </div>

      <div
        className='d-flex flex-column gap-2 book_card_actions'
        style={{ alignItems: 'flex-end' }}
      >
        <h6 className='content-skeleton m-0' style={{ height: '12px', width: '70px' }}></h6>
        <h5 className='content-skeleton m-0' style={{ height: '12px', width: '70px' }}></h5>
        <div
          className='book_title_container w-100'
          style={{ paddingTop: '10px', visibility: 'hidden' }}
        >
          <h4 className='content-skeleton m-0' style={{ height: '18px', width: '146px' }}></h4>
        </div>
        <h5 className='content-skeleton m-0' style={{ height: '14px', width: '70px' }}></h5>
      </div>
    </div>
  </div>
);
